import React from "react";
import { Link } from "react-router-dom";
import Dave from '../../assest/background/Dave.png';
function InvestRealState3() {
  document.title = "SimWealth";
  return (
    <>
      <div className="bg bg-InvestRealState2">
      <div data-aos="fade-left" className="container-fluid row  vh-100 w-100">
            <div  className="col-sm-6 d-flex align-items-center justify-content-center">
               <img src={Dave} className="DaveImage" alt="Dave" />
            </div>
            <div className="col-sm-6 d-flex flex-column align-items-end justify-content-center  text-center position-relative ">
            <Link to={'/choose-a-simulation'} className=" threeDButton btn fw-bold RightBtn ">MainMenu</Link>
                <div className="bg-white rounded-border p-4 border border-4 border-dark">
                <p className="py-5 my-5">Dave purchased his rental property with all cash. Dave does not believe in having debt, paying interest to the bank, or being stuck with mortgage payments for decades.</p>
                  <Link to={'/investing-in-real-estate/fourth-step'} className=" threeDButton btn fw-bold  w-50  ">Continue</Link>
                </div>
            </div>
        </div>
      </div>
    </>
  );
}

export default InvestRealState3;
